import isNil from 'lodash-es/isNil'
import isNull from 'lodash-es/isNull'
import { levelMap, LevelType } from '@/components/common/k-score/get-level'
import { I18nId } from '@/i18n/config'
import { PerformanceQuartileMetrics } from '@/types/schema/kpi-schema'

export interface RatingInfo {
  prRange: LevelType
  rating: I18nId
  color: string
  pr: number
}

const evaluateMetricPR = (
  metricValue: number | null | undefined,
  quartiles: PerformanceQuartileMetrics | null | undefined,
): RatingInfo | undefined => {
  if (isNil(metricValue) || isNil(quartiles)) {
    return undefined
  }

  const { pr25, pr50, pr75 } = quartiles

  if (isNull(pr25) || isNull(pr50) || isNull(pr75)) {
    return undefined
  }

  if (metricValue < pr25) {
    return {
      prRange: LevelType.Bad,
      rating: levelMap[LevelType.Bad].metricLevelI18nId,
      color: levelMap[LevelType.Bad].scoreColor,
      pr: 12.5,
    }
  }

  if (metricValue < pr50) {
    return {
      prRange: LevelType.Normal,
      rating: levelMap[LevelType.Normal].metricLevelI18nId,
      color: levelMap[LevelType.Normal].scoreColor,
      pr: 37.5,
    }
  }

  if (metricValue < pr75) {
    return {
      prRange: LevelType.Good,
      rating: levelMap[LevelType.Good].metricLevelI18nId,
      color: levelMap[LevelType.Good].scoreColor,
      pr: 62.5,
    }
  }

  return {
    prRange: LevelType.Excellent,
    rating: levelMap[LevelType.Excellent].metricLevelI18nId,
    color: levelMap[LevelType.Excellent].scoreColor,
    pr: 87.5,
  }
}

export default evaluateMetricPR
